// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"2c3ca02bcbc43dca","7173":"ebebec691dfc8f9b"}[chunkId] + ".css";
};